import { useTranslation } from 'react-i18next'
import { WetookMark } from '../components/WetookMark'

const MY_URL = ((import.meta as any).env?.VITE_MY_URL as string || '').replace(/\/$/, '')

/** Shown instead of the app shell when the signed-in user isn't scoped to
 *  this product app (see RequireAppAccess). Distinct from AccessDeniedPage
 *  (org suspended) — this is "you personally don't have this app yet", not
 *  "the whole org is locked out". */
export default function AppAccessDeniedPage({ appLabel }: { appLabel: string }) {
  const { t } = useTranslation()
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-background gap-6 text-center px-6">
      <WetookMark className="w-20 h-20 text-foreground opacity-80" />
      <div className="space-y-2">
        <p className="text-[11px] font-bold uppercase tracking-widest text-muted-foreground/60">
          {t('appAccess.eyebrow', '403 — App Not Available')}
        </p>
        <h1 className="text-2xl font-bold text-foreground">
          {t('appAccess.title', "You don't have access to {{app}}", { app: appLabel })}
        </h1>
        <p className="text-[14px] text-muted-foreground max-w-xs mx-auto leading-relaxed">
          {t('appAccess.desc', 'An org admin needs to grant you access to this app before you can use it.')}
        </p>
      </div>
      {MY_URL && (
        <a
          href={MY_URL}
          className="text-sm font-medium text-primary hover:underline"
        >
          {t('appAccess.backToMy', 'Back to My')}
        </a>
      )}
    </div>
  )
}
